import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldLabel, FieldValue, getScopeTypeLabel } from './SummaryShared';
import i18n from '../../i18n';

const SummaryEstimatedTotal = ({ attachments }) => {
  if (!attachments || attachments.length === 0) return null;

  // Group totals by scopeType
  const totalsByType = attachments.reduce((acc, att) => {
    if (att.estimatedScope && att.scopeType) {
      acc[att.scopeType] = (acc[att.scopeType] || 0) + Number(att.estimatedScope);
    }
    return acc;
  }, {});

  const entries = Object.entries(totalsByType);
  if (entries.length === 0) return null;

  const totalText = '~ ' + entries
    .map(([type, total]) => `${total} ${getScopeTypeLabel(type)}`)
    .join(', ');

  return (
    <Field>
      <FieldLabel>{i18n('translation_order_estimated_total')}</FieldLabel>
      <FieldValue>{totalText}</FieldValue>
    </Field>
  );
};

SummaryEstimatedTotal.propTypes = {
  attachments: PropTypes.array.isRequired,
};

export default SummaryEstimatedTotal;
